<template>
  <div class="des">
    <span>{{ msg }}</span>
  </div>
</template>

<script>
export default {
  name: 'des',
  data () {
    return {
      msg: '星络家居云物联科技有限公司是智能家居前装市场开拓者'
    }
  }
}
</script>
<style scoped>
.des{
  padding: 0 15px;
}
</style>
